import { ISkill } from "@core/models/common";

export const extracadabraSkillsMocks = [
  {
    [ISkill.id]: 44,
    [ISkill.label]: "Dressage des assiettes",
  },
  {
    [ISkill.id]: 45,
    [ISkill.label]: "Accueil client",
  },
];

export const suggestedSkillsMocks = [
  {
    [ISkill.id]: 12,
    [ISkill.label]: "Service à table",
  },
  {
    [ISkill.id]: 23,
    [ISkill.label]: "Efficace",
  },
];
